/**
 * Documentation KFP API
 * ## Common Request Headers - Authorization (string `Bearer {AccessToken}`, if signed-in) - After the client has successfully obtained `AccessToken` via Login, it\'s sent in every request as a bearer token.
 *
 * The version of the OpenAPI document: 1
 * Contact: novak@techcrowd.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SectionResource } from './sectionResource';
import { PlannerResource } from './plannerResource';
import { GroupResource } from './groupResource';


export interface ItemResource { 
    /**
     * Item ID
     */
    id: number;
    /**
     * Item title
     */
    title?: string;
    /**
     * Item description
     */
    description?: string;
    /**
     * Scheduled date
     */
    scheduledDate?: string;
    /**
     * Icon string
     */
    icon?: string;
    /**
     * Item order value
     */
    order?: number;
    /**
     * Item status
     */
    status?: ItemResource.StatusEnum;
    created?: string;
    updated?: string;
    group?: GroupResource;
    /**
     * List sections from item
     */
    sections?: Array<SectionResource>;
    /**
     * List planners from item
     */
    plannerData?: Array<PlannerResource>;
}
export namespace ItemResource {
    export type StatusEnum = 'concept' | 'inProgress' | 'published';
    export const StatusEnum = {
        Concept: 'concept' as StatusEnum,
        InProgress: 'inProgress' as StatusEnum,
        Published: 'published' as StatusEnum
    };
}


